import React from 'react';
import styled from 'styled-components';
import { TrevorComponent, WithIcon } from '../../types';

export type TextProps = React.ParamHTMLAttributes<HTMLParagraphElement> &
  WithIcon & {
    onClick?: (e: React.MouseEvent) => void;
    onMouseEnter?: () => void;
  };

export const TextRaw: TrevorComponent<TextProps, string | React.ReactNode> = ({
  children,
  className,
  dataTestId,
  icon,
  onClick,
  onMouseEnter,
}) => (
  <p className={className} data-testid={dataTestId}>
    {icon}
    {onClick ? (
      <button onClick={onClick} onMouseEnter={onMouseEnter}>
        {children}
      </button>
    ) : (
      <span>{children}</span>
    )}
  </p>
);

export const Text = styled(TextRaw)`
  --color: #666;

  align-items: center;
  display: flex;
  margin: 0;
  padding: 4px 0;

  a {
    color: var(--color);

    &:hover {
      color: #c2c2c2; // TODO: Clarify with Erin
    }
  }

  button {
    border: none;
    outline: none;
    padding: 0;
    background-color: transparent;
    border-bottom: 1px solid var(--color);
  }

  span,
  button {
    color: var(--color);
    font-size: 11px;
    line-height: 16px;
  }

  svg + span,
  svg + button {
    margin-left: 10px;
  }
`;
